import { takeLatest, call, put, all, fork } from 'redux-saga/effects';
import { cognitoForgotPassword } from '@services/cognitoUserService';
import {
  Types,
  onSendPasswordLinkFail,
  onSendPasswordLinkSuccess,
} from './actions';

function* callPostResetPasswordData(action) {
  try {
    const { email } = action.payload;

    const result = yield call(cognitoForgotPassword, email);
    if (!result?.success) {
      const err = result?.error;
      yield put(
        onSendPasswordLinkFail({
          code: err?.code || err?.name || err?.__type,
          message: err?.message || 'Failed to send reset code',
        }),
      );
      return;
    }
    yield put(onSendPasswordLinkSuccess({
      codeDeliveryDetails: result?.result?.codeDeliveryDetails || null,
    }));
  } catch (error) {
    yield put(
      onSendPasswordLinkFail({
        code: error?.code || error?.name || error?.__type,
        message: error?.message || String(error || 'Failed to send reset code'),
      }),
    );
  }
}

function* watchCallPostResetPasswordData() {
  yield takeLatest(Types.SEND_PASSWORD_LINK, callPostResetPasswordData);
}

export default function* watchLoginForgotPasswordActions() {
  yield all([fork(watchCallPostResetPasswordData)]);
}
